<template>
  <div id="Login" class="login fullheight" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <div class="login__background-shape"></div>
    <CContainer fluid class="fullheight"> 
      <CRow class="align-start align-md-center fullheight">
        <CCol cols="12" md="12" class="my-4 my-sm-8 my-md-0 login__column">
          <div style="width: 100%;">
            <div class="login__container" style="margin: auto !important;">
              <div class="login__inner">
                <div class="login__image">
                  <img src="main_logo.png" style="width: 140px; margin: 0 80px;" alt="Logo Oscuro">
                </div>
                <div class="login__header pt-5">
                    <h4>Inicia Sesión</h4>
                </div>
                <div class="login__subscribe d-flex justify-space-between align-center pb-8">
                    <p class="text-subtitle-2 ma-0" style="font-size: 12px;">{{welcome}}</p>
                    <!-- <a href="https://somosorderly.com/orderly-facturador-gratuito-pruebalo-gratis" class="custom-transform-class text-none font-weight-regular px-1">Regístrate aquí.</a> -->
                    <!-- <a href="/#/signup" class="custom-transform-class text-none font-weight-regular px-1">{{cta}}.</a> -->
                </div>
                <CForm class="login__form" @submit.prevent="login">
                  <CRow>
                    <CCol sm="12">
                      <CInput
                        v-model="email"
                        label="Correo Electrónico"
                        type="email"
                        autocomplete="username"
                        placeholder=""
                      />
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol sm="12" class="input-group">
                      <CInput
                        :type="passwordFieldType"
                        v-model="password"
                        autocomplete="current-password"
                        placeholder="Contraseña"
                        aria-label="Contraseña"
                        aria-describedby="togglePassword"
                        style="width: calc(100% - 46px);"
                      />
                      <div class="input-group-append">
                        <CButton @click="togglePasswordVisibility" color="light" class="btn btn-outline-secondary" style="height: 35px; padding-top: 4px;">
                          <CIcon :name="passwordIcon" style="color: #666666;" />
                        </CButton>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow v-if="loginError">
                    <CCol sm="12">
                      <p class="login__error">{{ loginError }}</p>
                    </CCol>
                  </CRow>
                  <br />
                  <CRow>
                    <CCol sm="12">
                      <CButton type="submit" color="primary" style="width: 100%" :disabled="isSubmitting">
                        {{ isSubmitting ? 'INGRESANDO...' : 'INICIAR SESIÓN' }}
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
                <div class="login__actions d-flex justify-space-between py-2">
                    <div class="login__remind" style="font-size: 12px;">
                    </div>
                    <div class="login__recovery-password" style="width: 100%">
                        <a href="/#/forget" class="font-weight-regular px-1" style="font-size: 12px; float: right !important;">¿Olvidaste tu contraseña?</a>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import login from '../../../services/login';
import ws from '../../../services/general';
import store from '../../../store'
import axios from 'axios'

export default {
  name: 'Login',
  data: function () {
      return {
          email: '',
          password: '',
      isSubmitting: false,
      loginError: '',
          showPassword: false,
          remind: false,
      welcome: 'Aquí podrás llevar todo el seguimiento de tu viaje.',
          cta: '',
          desktop: true
      }
  },
  computed: {
    passwordFieldType() {
      return this.showPassword ? 'text' : 'password';
    },
    passwordIcon() {
      return this.showPassword ? 'cil-lock-unlocked' : 'cil-lock-locked';
    }
  },
  mounted: async function() {
    try {
      let response = await ws.getParameters(); 

      if(response.type == "success"){
        let parameters = response.data;

        let param2 = this.$findElementByName(parameters, "LOGIN_WELCOME");
        if(param2 && param2.value){
          this.welcome = param2.value;
        }

        let param3 = this.$findElementByName(parameters, "LOGIN_CTA");
        if(param3 && param3.value){
          this.cta = param3.value;
        }
      }
    } catch (error) {
      this.welcome = 'Aquí podrás llevar todo el seguimiento de tu viaje.';
    }

    if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
        this.desktop = false;
    } else {
        this.desktop = true;
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    login: async function(){
      this.loginError = '';

      if(!this.email || !this.password){
        this.loginError = 'Ingresa tu correo y contraseña.';
        return;
      }

      this.isSubmitting = true;
      this.loading();

      let params = {
        email: (this.email || '').trim().toLowerCase(),
        password: this.password,
        desktop: this.desktop,
        device_name: navigator.userAgent
      };

      try {
        let response = await login.login(params);

        localStorage.removeItem("school_tab");
        localStorage.removeItem("travel_tab");

        if(response.type == "success"){
          let data = response.data;

          localStorage.setItem("token", data.access_token);

          axios.defaults.headers.common['access-token'] = data.access_token;

          if(data.role.slug == "normal"){
            window.location.href = "/#/app"; return;
          }

          window.location.href = "/#/"; return;
        }

        this.loginError = response.message || 'No fue posible iniciar sesión.';
      } catch (error) {
        this.loginError = this.resolveErrorMessage(error);
      } finally {
        this.isSubmitting = false;
        this.loaded();
      }
    },
    resolveErrorMessage(error){
      if(error && error.response && error.response.data){
        const status = error.response.status;
        const body = error.response.data;

        if(typeof body === 'string'){
          if(body.indexOf('Composer detected issues in your platform') >= 0){
            return 'El servidor de API reporta incompatibilidad de PHP/Composer. Contacta a soporte técnico.';
          }

          return status ? ('El servidor respondió con error ' + status + '.') : 'No fue posible iniciar sesión. Verifica tus datos e inténtalo nuevamente.';
        }

        return body.message || (status ? ('El servidor respondió con error ' + status + '.') : 'No fue posible iniciar sesión. Verifica tus datos e inténtalo nuevamente.');
      }

      return 'No fue posible conectar con el servidor. Revisa tu conexión e inténtalo nuevamente.';
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>

<style scoped>
.login__error {
  margin: 0;
  color: #b42318;
  font-size: 12px;
}
</style>
